//slick for collection here
$(document).ready(function() {   
    // Home banner slider
    $('.collection-hero__slider').slick({
            dots: false,
            fade:true,
            infinite: true,
            arrows:false, 
            autoplay: true,
            autoplaySpeed: 3000,
            adaptiveHeight: true,
            speed: 700,
            slidesToShow: 1,
            slidesToScroll: 1
        });
})